module.exports = __webpack_public_path__ + "img/no-code-no-bulk-img.df8edab9.png";